import { Assignment, Close, MarkUnreadChatAlt } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type ChatHeaderProps = {
  title?: string;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  onClose: () => void;
};

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  icon,
  description,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex drawer-header p-2 justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          {icon || (
            <MarkUnreadChatAlt fontSize="medium" sx={{ color: '#fff' }} />
          )}

          <span className="h5 mb-0 mx-2">
            {title || t('label_conversation_history')}
          </span>
        </div>
        <IconButton onClick={onClose}>
          <Close sx={{ color: '#fff' }} />
        </IconButton>
      </div>
      {description ? (
        <div className="p-2 d-flex align-items-center">
          <Assignment />
          <span className="question mx-2">{description}</span>
        </div>
      ) : null}
    </>
  );
};
